import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';


export const routes: Routes = [
  { path: '', redirectTo: 'pages/login', pathMatch: 'full' },
  { path: 'pages/lockscreen', redirectTo: 'pages/lockscreen' },
  { path: 'pages/page-404', redirectTo: 'pages/page-404' },
  { path: 'pages/page-500', redirectTo: 'pages/page-500' },
  { path: 'pages/register', redirectTo: 'pages/register' },
  { path: '**', redirectTo: 'pages/page-404' },
 
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });//



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/app.routing.ts